module.exports = __webpack_public_path__ + "static/media/33.d7cd8f75.JPG";